export const siteStats = [
  { value: '320+', label: '已打包专题' },
  { value: '1,200+', label: '时间线节点' },
  { value: '6', label: '内容分类' },
  { value: '每日', label: '更新频率' },
];

export const valueProps = [
  {
    icon: 'ri-git-commit-line',
    title: '按事件打包',
    desc: '不再是一条条零散动态，而是把同一个事件的所有节点收进一个专题，从头看到尾。',
  },
  {
    icon: 'ri-time-line',
    title: '时间线梳理',
    desc: '每个专题都以时间线呈现，先发生什么、后发酵什么，脉络一目了然。',
  },
  {
    icon: 'ri-links-line',
    title: '关键信息聚合',
    desc: '把公开回应、媒体报道与网友讨论的要点归纳到一处，省去跨平台来回切换。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续跟进更新',
    desc: '有新的进展就会补进原专题，你收藏的合集不会停在旧版本。',
  },
];

export const testimonials = [
  {
    name: '小满',
    role: '追综艺三年',
    text: '以前追一个瓜要在好几个平台来回翻，现在直接看合集时间线，十分钟就能把来龙去脉搞清楚，太省事了。',
  },
  {
    name: '阿柚',
    role: '内容爱好者',
    text: '最喜欢它的时间线排版，节点写得很清楚，不会看完还是一头雾水。更新也跟得上。',
  },
  {
    name: '老周',
    role: '普通吃瓜群众',
    text: '不站队、不带节奏，就把事情按顺序说清楚，这种克制的写法反而更耐看。',
  },
  {
    name: 'Nana',
    role: '娱乐行业从业者',
    text: '做行业观察的时候会来查资料，节点整理得比较规范，标注了公开信息的时间，方便回溯。',
  },
  {
    name: '小柯',
    role: '学生党',
    text: '分类很清楚，想看哪一类的瓜直接进对应分类就行，不用被首页推荐牵着走。',
  },
  {
    name: '糖不甜',
    role: '内容创作者',
    text: '合集里的关键看点总结得不错，我整理自己节目脚本的时候经常参考它的结构。',
  },
];

export const faqs = [
  {
    q: '看瓜爆料的「合集」和普通资讯有什么不同？',
    a: '普通资讯是一条条独立发布的动态，看完一条很难知道前因后果。合集则把同一个事件的所有节点按时间顺序整理进一个专题，从起因、发酵到后续处理都收在一处，一次看个够。',
  },
  {
    q: '专题内容会一直更新吗？',
    a: '会。只要事件有新的公开进展，我们就会把新节点补充进原有专题，并在专题顶部标注最近的更新时间。你收藏的合集不会停留在旧版本。',
  },
  {
    q: '合集里的内容都来自哪里？',
    a: '专题只整理公开可查的信息，包括各方公开发布的回应、媒体报道的要点以及公开平台上的讨论脉络。我们不发布未经证实的指控，也不站队评价当事人。',
  },
  {
    q: '为什么有些人物用了「某顶流」「某演员」这样的写法？',
    a: '这是为了避免对具体个人作出未经证实的指向，也是内容合规的基本要求。我们关注的是事件本身的脉络，而不是给某个人贴标签。',
  },
  {
    q: '可以按分类找我想看的专题吗？',
    a: '可以。首页有六个内容分类入口，合集库页面还支持关键词搜索、分类筛选和按更新时间或热度排序，方便你快速定位感兴趣的方向。',
  },
  {
    q: '订阅之后会收到什么？',
    a: '会不定期收到本周新增专题和重点更新的汇总邮件，只发内容相关的提醒，不会频繁打扰，也可以随时取消。',
  },
];

export const contentPrinciples = [
  {
    icon: 'ri-shield-check-line',
    title: '只整理公开信息',
    desc: '所有节点均来自公开渠道，不采用无法核实的爆料，也不对当事人作出主观评判。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '多方说法并列',
    desc: '当事件存在不同说法时，会把各方公开回应如实并列呈现，让读者自行判断。',
  },
  {
    icon: 'ri-time-line',
    title: '按时间先后呈现',
    desc: '坚持时间线结构，先发生的在前、后发生的在后，避免信息错位带来的误读。',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '理性吃瓜',
    desc: '不煽动对立、不引导网暴，鼓励把注意力放回作品与事件本身。',
  },
];

export const aboutVoices = [
  {
    name: '林编辑',
    role: '内容行业观察者',
    text: '把时间线做成可回溯的结构，是内容站里少见的克制做法，查资料时很省时间。',
  },
  {
    name: '小鹿',
    role: '连续使用 8 个月',
    text: '从一个专题入坑，现在基本每周都会来合集库看看新增了什么。',
  },
  {
    name: '陈同学',
    role: '新媒体专业学生',
    text: '写课程作业分析传播路径时，这里的节点整理给了我很大帮助。',
  },
];

export const milestones = [
  { date: '2024 年初', title: '站点起步', desc: '从整理第一份时间线专题开始，确定「按事件打包」的内容方向。' },
  { date: '2024 年底', title: '建立分类体系', desc: '把内容拆成情感、事业、金钱、剧组、综艺、商务六个方向。' },
  { date: '2025 年中', title: '上线合集库', desc: '支持关键词搜索与筛选排序，专题规模突破两百个。' },
  { date: '2026 年', title: '持续更新机制', desc: '专题内节点可增量补充，最近更新时间全部公开标注。' },
];